// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".task-container-body[data-v-41c247af] {\n  height: 85vh;\n}\n.task-container-iframe[data-v-41c247af] {\n  width: 100%;\n  height: 100%;\n  border: 0;\n  overflow: hidden;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n.task-container[data-v-41c247af]  .el-dialog--center .el-dialog__body {\n  padding: 0;\n}", ""]);
// Exports
module.exports = exports;
